export class User {
    constructor(
        public username: string = '',
        public name: string = '',
        public password: string = '',
        public email: string = '',
        public cellphone: string = '',
        public creci_code: string = '',
        public creci_state: string = '',
        public challengeName: any = null,
        public challengeParam: any = null,
        public source: any = null,
        public verificationCode: string = '',
        public groups: string = '') { }
}
